export function resolveEmailBuilderCanvasRailPinLeft(args: {
  blockRect: DOMRect;
  canvasRect: DOMRect;
  frameRect: DOMRect | null;
  railWidth: number;
  leftChromeInsetPx: number;
  rightChromeInsetPx?: number;
  constrainToEmailFrame?: boolean;
  clampRightEdge?: boolean;
}): number {
  const edgeMarginPx = 8;
  const rightChromeInsetPx = args.rightChromeInsetPx ?? 0;
  const constrainToEmailFrame = args.constrainToEmailFrame ?? true;
  const clampRightEdge = args.clampRightEdge ?? true;
  const shellMinLeft = args.canvasRect.left + args.leftChromeInsetPx;
  const shellMaxLeft =
    args.canvasRect.right - args.railWidth - edgeMarginPx - rightChromeInsetPx;
  const emailMinLeft = args.frameRect
    ? args.frameRect.left + edgeMarginPx
    : shellMinLeft;
  const emailMaxLeft = args.frameRect
    ? args.frameRect.right - args.railWidth - edgeMarginPx
    : shellMaxLeft;
  const minLeft = constrainToEmailFrame ? Math.max(shellMinLeft, emailMinLeft) : shellMinLeft;
  const maxLeft = constrainToEmailFrame ? Math.min(shellMaxLeft, emailMaxLeft) : shellMaxLeft;
  const rightAnchoredLeft = args.blockRect.right - args.railWidth;
  const leftAnchoredLeft = args.blockRect.left;
  const emailMaxRight = args.frameRect
    ? args.frameRect.right - edgeMarginPx
    : args.canvasRect.right - edgeMarginPx - rightChromeInsetPx;
  const anchorMaxRight = constrainToEmailFrame
    ? emailMaxRight
    : args.canvasRect.right - edgeMarginPx - rightChromeInsetPx;
  const leftAnchorOverflowsFrame = leftAnchoredLeft + args.railWidth > anchorMaxRight;
  let preferredLeft = leftAnchoredLeft;
  if (
    clampRightEdge &&
    leftAnchorOverflowsFrame &&
    rightAnchoredLeft >= minLeft &&
    rightAnchoredLeft <= maxLeft
  ) {
    preferredLeft = rightAnchoredLeft;
  }

  if (!clampRightEdge) {
    return Math.max(preferredLeft, minLeft);
  }

  if (maxLeft < minLeft) {
    return minLeft;
  }

  return Math.min(Math.max(preferredLeft, minLeft), maxLeft);
}

export function resolveEmailBuilderCanvasRailPinMaxWidthAtLeft(args: {
  canvasRect: DOMRect;
  leftPx: number;
  rightChromeInsetPx?: number;
}): number {
  const edgeMarginPx = 8;
  const rightChromeInsetPx = args.rightChromeInsetPx ?? 0;
  const shellSafeRight = args.canvasRect.right - edgeMarginPx - rightChromeInsetPx;
  return Math.max(0, shellSafeRight - args.leftPx);
}
